// extracted by mini-css-extract-plugin
export default {"more":"MoreArrow_more__dSfQL","more__arrow":"MoreArrow_more__arrow__ddUYm","active":"MoreArrow_active__4GPBv"};